import { useLocalization } from '@ais-ui/locale-management';
import { AccordionContent } from '@ais-ui/ui-core';
import React from 'react';
import { AtonHost } from '@ais-ui/api';

interface HostAtonItemContentProps {
  aton: AtonHost;
  children?: React.ReactNode;
}

export const HostAtonItemContent = ({
  aton,
  children,
}: HostAtonItemContentProps) => {
  const { messages } = useLocalization();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  return (
    <AccordionContent>
      <div className="space-y-4">
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">IP Address:</p>
          <p>{aton.ipAddress}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">Site Type:</p>
          <p className="capitalize">{aton.siteType}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">Status:</p>
          <p>{aton.isOffline ? 'Offline' : 'Online'}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">Created:</p>
          <p>{formatDate(aton.createdAt)}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">Updated:</p>
          <p>{formatDate(aton.updatedAt)}</p>
        </div>
        <div className="flex px-4 space-x-2 items-center">
          <p className="text-muted-foreground">Created By:</p>
          <p className="capitalize">{aton.createdBy}</p>
        </div>
        {children}
      </div>
    </AccordionContent>
  );
};
